import { useQuery } from 'react-query'

import { useUserProvider } from '../../components/Context/UserContext'
import { CacheKeys } from '../../helpers/cacheKeys'
import { getIssuesForUser } from '../../models/issue'

export function useIssues(userId: string, { enabled = true } = {}) {
  const { loggedInUser } = useUserProvider()

  const { data, isLoading, isFetching, refetch } = useQuery(
    `${CacheKeys.ISSUES}-${userId}-${loggedInUser?.id}`,
    () => getIssuesForUser(userId),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      enabled,
    }
  )

  return {
    issues: data,
    refetch,
    isLoading,
    isFetching,
  }
}
